import { render, staticRenderFns } from "./CarKeyboard.vue?vue&type=template&id=487c299e&scoped=true"
import script from "./CarKeyboard.vue?vue&type=script&lang=js"
export * from "./CarKeyboard.vue?vue&type=script&lang=js"
import style0 from "./CarKeyboard.vue?vue&type=style&index=0&id=487c299e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c299e",
  null
  
)

export default component.exports